// Angular
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-field-search-input',
    templateUrl: './field-search-input.component.html',
    styleUrls: ['./field-search-input.component.scss'],
    standalone: false
})
export class FieldSearchInputComponent implements AfterViewInit {
    @Input() model: any = null;
    @Input() placeholder: string = '';
    @Input() focus: string = '';
    @Input() loading: boolean = false;

    @Output() modelChange = new EventEmitter();
    @Output() enter = new EventEmitter();
    @Output() clear = new EventEmitter();

    @ViewChild('myinput') myInputField: ElementRef;
    ngAfterViewInit() {
        if (this.focus) {
            this.myInputField.nativeElement.focus();
        }
    }
}
